import { render, staticRenderFns } from "./RateCodePeriodList.vue?vue&type=template&id=06e8f943&scoped=true"
import script from "./RateCodePeriodList.vue?vue&type=script&lang=js"
export * from "./RateCodePeriodList.vue?vue&type=script&lang=js"
import style0 from "./RateCodePeriodList.vue?vue&type=style&index=0&id=06e8f943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8f943",
  null
  
)

export default component.exports